// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/LandingPageImages/Arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Landingpage {
  background-color: white;
}

.Switch {
  width: 90%;

  display: flex;

  margin: auto;
}

.Navbar {
  width: 100%;

  height: 48px;

  background-color: #f3f2f0;
}

.Logo {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 25px;
}
.Logo img {
  object-fit: contain;
  margin-left: 24px;
}

.content {
  width: 100%;
}

.mainHeading {
  margin: 50px 0px 20px 0px;

  font-size: 38px;

  font-weight: normal;
  color: #373334;
  font-weight: 600;
}

.mainText {
  font-size: 24px;
  /* font-weight: lighter; */
  font-weight: 300;
  line-height: 30px;
  color: #373334;
  /* color: #373334; */
}

.imageContent {
  display: flex;
  flex-wrap: wrap;
}

.image {
  flex-basis: 25%;
  height: auto;
  width: auto;
}

.image img {
  width: 100%;
  height: 100%;
}

.information {
  background-color: #f3f2f0;

  min-height: 300px;

  display: flex;

  justify-content: space-around;
}

.info-content {
  text-align: center;

  max-width: 300px;

  margin: 0 auto;
}

.info-img {
  height: 120px;

  display: flex;

  align-items: center;

  justify-content: center;
}

.info-content p {
  width: 100%;

  text-align: center;

  line-height: 25px;

  font-weight: normal;

  margin-top: 10%;
  color: #373334;
}

.contentImage {
  height: 400px;
}

.contentImage img {
  max-width: 500px;
}

.contentList {
  list-style-type: none;

  width: 80%;

  margin: 0px;

  margin-left: 10%;
}

.contentInfo {
  padding-top: 8%;
}

.contentListItems {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-size: 20px;

  background-repeat: no-repeat;

  background: position 0px 20px;

  margin-bottom: 20px;

  line-height: 25px;

  font-size: 24px;

  letter-spacing: 1px;

  padding-left: 40px;
}

.footer {
  background-color: #f3f2f0;

  padding: 40px 0;

  text-align: center;
}

.skopicInfo {
  width: 90%;

  min-height: 200px;

  border-radius: 20px;

  margin: auto;

  background-color: white;

  padding: 50px;
}

.skopicInfo p {
  font-size: 24px;

  color: #373334;

  /* font-weight: 700; */
}

.SocailSignIn {
  padding: 8px;

  display: flex;

  justify-content: center;

  align-items: center;

  cursor: pointer;

  border-radius: 20px;

  margin: 20px auto 0 auto;

  text-align: center;
}

.demoImge {
  width: 32px;

  margin-left: 10px;
}

.mobileLinks {
  margin: auto;
}

.mobileLinks img {
  width: 127px;

  margin: 0 10px;
}

.socialLinks {
  margin: auto;
}

.socialLinks img {
  width: 35px;

  margin: 0 10px;
}

.appLinks {

  font-weight: 300;

  margin: auto;

  margin-top: 2%;

  /* border:1px solid ; */
}

.copyright {
  margin-top: 2%;
}

.copyrightRules {
  color: #7a7a7a;
  text-align: center;

  font-weight: 300;
}

.abountSkopic {
  margin-top: 125px;
}

@media (max-width: 768px) {
  .skopicInfo {
    padding-top: 20px;

    padding-bottom: 20px;
  }

  .skopicInfo p {
    margin-top: 20px;

    margin-bottom: 0;
  }

  .contentImage {
    text-align: center;

    height: auto;
  }

  .contentImage img {
    max-width: 300px;

    margin: 0 auto;
  }

  .contentList {
    margin: 0;

    width: 100%;
  }

  .abountSkopic {
    margin-top: 0;
  }

  .image {
    flex-basis: 50%;
  }
}

.MuiInput-underline:before,
.MuiInput-underline:after,
.MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: 0 !important;
}

.MuiInput-underline.Mui-focused:after {
  transform: scaleX(0) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/LandingPage/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;;EAEV,aAAa;;EAEb,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;;EAEzB,eAAe;;EAEf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;;EAEjB,aAAa;;EAEb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,aAAa;;EAEb,aAAa;;EAEb,mBAAmB;;EAEnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;;EAElB,iBAAiB;;EAEjB,mBAAmB;;EAEnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;;EAErB,UAAU;;EAEV,WAAW;;EAEX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yDAA+D;;EAE/D,qBAAqB;;EAErB,4BAA4B;;EAE5B,6BAA6B;;EAE7B,mBAAmB;;EAEnB,iBAAiB;;EAEjB,eAAe;;EAEf,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;;EAEzB,eAAe;;EAEf,kBAAkB;AACpB;;AAEA;EACE,UAAU;;EAEV,iBAAiB;;EAEjB,mBAAmB;;EAEnB,YAAY;;EAEZ,uBAAuB;;EAEvB,aAAa;AACf;;AAEA;EACE,eAAe;;EAEf,cAAc;;EAEd,sBAAsB;AACxB;;AAEA;EACE,YAAY;;EAEZ,aAAa;;EAEb,uBAAuB;;EAEvB,mBAAmB;;EAEnB,eAAe;;EAEf,mBAAmB;;EAEnB,wBAAwB;;EAExB,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;;EAEhB,YAAY;;EAEZ,cAAc;;EAEd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;;IAEjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;;IAEhB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;;IAElB,YAAY;EACd;;EAEA;IACE,gBAAgB;;IAEhB,cAAc;EAChB;;EAEA;IACE,SAAS;;IAET,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".Landingpage {\r\n  background-color: white;\r\n}\r\n\r\n.Switch {\r\n  width: 90%;\r\n\r\n  display: flex;\r\n\r\n  margin: auto;\r\n}\r\n\r\n.Navbar {\r\n  width: 100%;\r\n\r\n  height: 48px;\r\n\r\n  background-color: #f3f2f0;\r\n}\r\n\r\n.Logo {\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 25px;\r\n}\r\n.Logo img {\r\n  object-fit: contain;\r\n  margin-left: 24px;\r\n}\r\n\r\n.content {\r\n  width: 100%;\r\n}\r\n\r\n.mainHeading {\r\n  margin: 50px 0px 20px 0px;\r\n\r\n  font-size: 38px;\r\n\r\n  font-weight: normal;\r\n  color: #373334;\r\n  font-weight: 600;\r\n}\r\n\r\n.mainText {\r\n  font-size: 24px;\r\n  /* font-weight: lighter; */\r\n  font-weight: 300;\r\n  line-height: 30px;\r\n  color: #373334;\r\n  /* color: #373334; */\r\n}\r\n\r\n.imageContent {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.image {\r\n  flex-basis: 25%;\r\n  height: auto;\r\n  width: auto;\r\n}\r\n\r\n.image img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.information {\r\n  background-color: #f3f2f0;\r\n\r\n  min-height: 300px;\r\n\r\n  display: flex;\r\n\r\n  justify-content: space-around;\r\n}\r\n\r\n.info-content {\r\n  text-align: center;\r\n\r\n  max-width: 300px;\r\n\r\n  margin: 0 auto;\r\n}\r\n\r\n.info-img {\r\n  height: 120px;\r\n\r\n  display: flex;\r\n\r\n  align-items: center;\r\n\r\n  justify-content: center;\r\n}\r\n\r\n.info-content p {\r\n  width: 100%;\r\n\r\n  text-align: center;\r\n\r\n  line-height: 25px;\r\n\r\n  font-weight: normal;\r\n\r\n  margin-top: 10%;\r\n  color: #373334;\r\n}\r\n\r\n.contentImage {\r\n  height: 400px;\r\n}\r\n\r\n.contentImage img {\r\n  max-width: 500px;\r\n}\r\n\r\n.contentList {\r\n  list-style-type: none;\r\n\r\n  width: 80%;\r\n\r\n  margin: 0px;\r\n\r\n  margin-left: 10%;\r\n}\r\n\r\n.contentInfo {\r\n  padding-top: 8%;\r\n}\r\n\r\n.contentListItems {\r\n  background-image: url(../../images/LandingPageImages/Arrow.svg);\r\n\r\n  background-size: 20px;\r\n\r\n  background-repeat: no-repeat;\r\n\r\n  background: position 0px 20px;\r\n\r\n  margin-bottom: 20px;\r\n\r\n  line-height: 25px;\r\n\r\n  font-size: 24px;\r\n\r\n  letter-spacing: 1px;\r\n\r\n  padding-left: 40px;\r\n}\r\n\r\n.footer {\r\n  background-color: #f3f2f0;\r\n\r\n  padding: 40px 0;\r\n\r\n  text-align: center;\r\n}\r\n\r\n.skopicInfo {\r\n  width: 90%;\r\n\r\n  min-height: 200px;\r\n\r\n  border-radius: 20px;\r\n\r\n  margin: auto;\r\n\r\n  background-color: white;\r\n\r\n  padding: 50px;\r\n}\r\n\r\n.skopicInfo p {\r\n  font-size: 24px;\r\n\r\n  color: #373334;\r\n\r\n  /* font-weight: 700; */\r\n}\r\n\r\n.SocailSignIn {\r\n  padding: 8px;\r\n\r\n  display: flex;\r\n\r\n  justify-content: center;\r\n\r\n  align-items: center;\r\n\r\n  cursor: pointer;\r\n\r\n  border-radius: 20px;\r\n\r\n  margin: 20px auto 0 auto;\r\n\r\n  text-align: center;\r\n}\r\n\r\n.demoImge {\r\n  width: 32px;\r\n\r\n  margin-left: 10px;\r\n}\r\n\r\n.mobileLinks {\r\n  margin: auto;\r\n}\r\n\r\n.mobileLinks img {\r\n  width: 127px;\r\n\r\n  margin: 0 10px;\r\n}\r\n\r\n.socialLinks {\r\n  margin: auto;\r\n}\r\n\r\n.socialLinks img {\r\n  width: 35px;\r\n\r\n  margin: 0 10px;\r\n}\r\n\r\n.appLinks {\r\n\r\n  font-weight: 300;\r\n\r\n  margin: auto;\r\n\r\n  margin-top: 2%;\r\n\r\n  /* border:1px solid ; */\r\n}\r\n\r\n.copyright {\r\n  margin-top: 2%;\r\n}\r\n\r\n.copyrightRules {\r\n  color: #7a7a7a;\r\n  text-align: center;\r\n\r\n  font-weight: 300;\r\n}\r\n\r\n.abountSkopic {\r\n  margin-top: 125px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .skopicInfo {\r\n    padding-top: 20px;\r\n\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .skopicInfo p {\r\n    margin-top: 20px;\r\n\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .contentImage {\r\n    text-align: center;\r\n\r\n    height: auto;\r\n  }\r\n\r\n  .contentImage img {\r\n    max-width: 300px;\r\n\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .contentList {\r\n    margin: 0;\r\n\r\n    width: 100%;\r\n  }\r\n\r\n  .abountSkopic {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .image {\r\n    flex-basis: 50%;\r\n  }\r\n}\r\n\r\n.MuiInput-underline:before,\r\n.MuiInput-underline:after,\r\n.MuiInput-underline:hover:not(.Mui-disabled):before {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.MuiInput-underline.Mui-focused:after {\r\n  transform: scaleX(0) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
